import SidebarLayout from "../../../../../layouts/SidebarLayout";
import { officeSettingsTabList } from "../officeSettingsTabList";
import GeneralSettings from "./_components/GeneralSettings";
import TemplateBuilderPanel from "./_components/TemplateBuilderPanel";

export default function NotificationSetting() {
  return (
    <SidebarLayout title="Notification Setting" tabList={officeSettingsTabList}>
      <GeneralSettings />
      <TemplateBuilderPanel />
    </SidebarLayout>
  );
}
